import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

const WhitePage = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledCircularProgress = styled(CircularProgress)`
    margin: auto;
`;

export const LoaderPage = () => {
    return (
        <WhitePage>
            <StyledCircularProgress size="95px" />
        </WhitePage>
    );
};
